import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import {
  CardImg, CardInput, CardInputBox,
  MyLoginButton, Form, Header, CardInputLabelCenter,
} from './styledLoginComp';
import { Mail } from '../Styled/Buttons/icons';
import useAuth from './hooks/useAuth';
import LoginMsg from './loginMsg';

function ResetPassword() {
  const { resetPassHandler } = useAuth();
  const { path, url } = useRouteMatch();

  const lenUrl = path.trim().length - 4;
  const initEmail = url.includes('@') ? url.trim().slice(lenUrl + 1) : '';
  const [email, setEmail] = useState(initEmail);

  const [showMsg, setShowMsg] = useState('');

  const [disabledSend, setDisabledSend] = useState(false);

  const resetPass = () => resetPassHandler(email, setShowMsg);

  return (
    <div style={{
      display: 'flex', FlexDirection: 'rows', justifyContent: 'center', alignItems: 'center', marginTop: '10%',
    }}
    >
      <Form>
        <Header>Перевстановлення паролю</Header>
        <CardInputLabelCenter>
          На вказану ел.адресу користувача надійде лист-запрошення для перевстановлення паролю
        </CardInputLabelCenter>
        <CardInputBox>
          <CardImg>
            <img height="25px" width="30px" src={Mail} alt="" />
            <CardInput
              placeholder="Введіть ел.адресу користувача"
              name="ел.адреса"
              type="email"
              className="card-input"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </CardImg>
        </CardInputBox>
        <br />
        <MyLoginButton
          content="Надіслати"
          disabled={disabledSend}
          onClick={() => {
            setDisabledSend(true);
            resetPass();
          }}
        />
      </Form>

      <LoginMsg open={showMsg} msg={showMsg} />

    </div>
  );
}

export default ResetPassword;
